import sanityClient from '../sanityClient';

/**
 * Fetch hero section content from Sanity CMS
 * @returns {Promise<Object|null>} Hero section data or null if not found
 */
export const fetchHeroContent = async () => {
  try {
    // GROQ query to fetch the first hero section document
    const query = `*[_type == "heroSection"][0]{
      eyebrow,
      title,
      subtitle,
      artButtonText,
      judaicaButtonText,
      artistsCount,
      itemsCount,
      "backgroundImage": backgroundImage.asset->url
    }`;

    const data = await sanityClient.fetch(query);
    return data;
  } catch (error) {
    console.error('Error fetching hero content from Sanity:', error);
    throw error;
  }
};

export const fetchCategories = async () => {
  try {
    const query = `*[_type == "category"]{
      _id, title, "slug": slug.current, description,
      image { asset->{url}, alt },
      "parentSlug": parent->slug.current
    }`;
    return await sanityClient.fetch(query);
  } catch (error) {
    console.error('Error fetching categories from Sanity:', error);
    throw error;
  }
};

/**
 * Check if Sanity client is properly configured
 * @returns {boolean} True if configured, false otherwise
 */
export const isSanityConfigured = () => {
  return !!(
    process.env.REACT_APP_SANITY_PROJECT_ID &&
    process.env.REACT_APP_SANITY_DATASET
  );
};
